import { NotificationConfig, NOTI_FREQ } from "../../interfaces";

import "../../styles/notiEdit.css";

export const NotificationSettingEdit = ({
    name,
    config,
    updateConfig,
}: {
    name: string;
    config: NotificationConfig;
    updateConfig: (x: NotificationConfig) => void;
}) => {
    return (
        <div className="wrapper">
            <div className="checkWrapper">
                <label htmlFor="reminder">{name}</label>
                <input
                    type="checkbox"
                    name="reminder"
                    checked={config.active}
                    onChange={() =>
                        updateConfig({ ...config, active: !config.active })
                    }
                />
            </div>

            <input
                className="timepicker"
                type="time"
                defaultValue={config.timestamp}
                onChange={(e) =>
                    updateConfig({ ...config, timestamp: e.target.value })
                }
            />

            <select
                className="freqSelector"
                value={config.freq}
                onChange={(e) =>
                    updateConfig({ ...config, freq: +e.target.value })
                }
            >
                <option value={NOTI_FREQ.DAILY}>Daily</option>
                <option value={NOTI_FREQ.WEEKLY}>Weekly</option>
                <option value={NOTI_FREQ.MONTHLY}>Monthly</option>
            </select>
        </div>
    );
};
